import { ShieldCheck, Clock, Users, Sparkles } from "lucide-react";
import { FadeUp } from "./Reveal";

const BADGES = [
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: Clock, label: "25+ Years Experience" },
  { icon: Users, label: "Family-Owned" },
  { icon: Sparkles, label: "Free Estimates" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="bg-[#0E2A1A] text-[#FFFFFF] py-6 md:py-8"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
        {BADGES.map(({ icon: Icon, label }, i) => (
          <FadeUp
            key={label}
            delay={i * 0.06}
            data-testid={`trust-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="flex items-center gap-3"
          >
            <Icon className="w-4 h-4 text-[#DA7B3C]" strokeWidth={1.75} />
            <span className="font-mono-sm text-[#FFFFFF]">{label}</span>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
